import React, { useState, useEffect, useContext } from 'react'
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import ListingItem from './items/listingItem'
import { VendorContext } from '../../../contexts/vendorContext'
import { ItemCard } from '../../../models/Item'
import { PaginationLimit } from '../../../config/enums'
import VendorListingRepo from '../../../repos/vendorListingRepo'

const VendorListing = () => {
  const vendorContext = useContext(VendorContext)
  const vendorId = vendorContext?.profile?.vendorId
  const [vendorListings, setVendorListings] = useState<ItemCard[]>([])
  const [limitSearch, setLimitSearch] = useState(PaginationLimit.listings)
  const [isLoading] = useState(false)

  // Display load more button if limit is more than total array size
  const loadMoreButtonVisibility = (total: number) => {
    if (total < limitSearch) {
      return false
    } else {
      return true
    }
  }

  const [repo] = useState(() => {
    // Subscribe to firestore and add listener
    return new VendorListingRepo(vendorId!, limitSearch, newItems => {
      setVendorListings(newItems)
    })
  })

  useEffect(() => {
    return () => {
      // Unsubscribe to firestore upon component unmount
      repo.stopListening()
    }
  }, [repo])

  const [searchText, setSearchText] = useState('')
  useEffect(() => {
    // Update firestore query when search text changed
    repo.setSearchTextAndLimit(searchText, limitSearch)
  }, [searchText, limitSearch, repo])

  return (
    <>
      <Row data-testid="listing-management">
        <Col className="pb-3">
          <h1 className="largeTitle">Listings</h1>
        </Col>
      </Row>
      <Row>
        <Col xs={4} className="mx-auto text-center pb-3 ">
          <Link to="/vendor/addlisting" className="font-teal">
            <Button variant="secondary" className="text-white">
              <b>Add a listing</b>
            </Button>
          </Link>
        </Col>
      </Row>
      <Row>
        <Col lg={3}>
          <p>Search:</p>
          <Form.Control
            type="text"
            placeholder="enter listing name"
            data-testid="searchField"
            value={searchText}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setLimitSearch(PaginationLimit.listings)
              setSearchText(e.target.value)
            }}
          />
        </Col>
      </Row>
      <Row className="pt-5">
        {vendorListings.length === 0 ? (
          <Col>No match.</Col>
        ) : (
          vendorListings.map(itemData => {
            return (
              <ListingItem
                key={itemData.itemId}
                itemId={itemData.itemId}
                imageSrc={itemData.imageSrc}
                itemTitle={itemData.itemTitle}
                itemDesc={itemData.itemDesc}
                itemButton={itemData.itemButton}
                itemButtonUrl={itemData.itemButtonUrl}
                itemActive={itemData.itemActive}
                itemPrice={itemData.itemPrice}
              />
            )
          })
        )}
      </Row>
      <Row>
        <Col
          xs={10}
          lg={{ span: 3, offset: 5 }}
          className="mx-auto text-center py-5"
        >
          {loadMoreButtonVisibility(vendorListings.length) && (
            <button
              onClick={() => {
                // Adds the limit as defined by Pagionation Limit enum
                setLimitSearch(limitSearch + PaginationLimit.listings)
              }}
              className={`mochi-button `}
            >
              {isLoading ? (
                <Spinner animation="border" variant="light" />
              ) : (
                'Load more'
              )}
            </button>
          )}
        </Col>
      </Row>
    </>
  )
}

export default VendorListing
